import { createCompositeStore } from "../composite/composite-store.js";
import { createStore } from "@ariakit/store";
import { defaultValue } from "@ariakit/utils";
//#region src/radio/radio-store.ts
/**
* Creates a radio store.
*/
function createRadioStore(props = {}) {
	const syncState = props.store?.getState();
	const composite = createCompositeStore({
		...props,
		focusLoop: defaultValue(props.focusLoop, syncState?.focusLoop, true)
	});
	const radio = createStore({
		...composite.getState(),
		value: defaultValue(props.value, syncState?.value, props.defaultValue, null)
	}, composite, props.store);
	return {
		...composite,
		...radio,
		setValue: (value) => radio.setState("value", value)
	};
}
//#endregion
export { createRadioStore };

//# sourceMappingURL=radio-store.js.map